<script>
export default {
  components: {},
  props: {
    artworks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="send-data">
          <h5 class="artist-titel">{{ $t("pages.artist.card_info.artist_title") }}</h5>
          <ul class="mb-0">
            <li v-for="(art, index) in artworks" :key="index">
              <p>
                <span>{{ art.main_name }}</span>
                <i class="mdi mdi-chevron-left"></i>
                <span>{{ art.sub_name }}</span>
                <i class="mdi mdi-chevron-left"></i>
                <span>{{ art.artwork_name }}</span>
              </p>
            </li>
          </ul>
          <h5 class="my-3 text-center">
            {{ $t("pages.artist.form_wizard.tab-content.send.h4_text") }}
          </h5>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
